// extracted by mini-css-extract-plugin
export default {"getReportButton":"PurchaseReportButton_getReportButton__XMz80"};